<template>
  <div>
    {{ game }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      game: {},
    };
  },
  created() {
    this.game = localStorage.getItem('game');
  }
}
</script>